import React, { useEffect, useState } from 'react';
export function UrgencyCountdown() {
  const TOTAL_SECONDS = 15 * 60; // 15 minutes
  const [secondsLeft, setSecondsLeft] = useState(() => {
    const saved = sessionStorage.getItem('urgency-countdown');
    if (saved) {
      const parsed = parseInt(saved, 10);
      return parsed > 0 ? parsed : TOTAL_SECONDS;
    }
    return TOTAL_SECONDS;
  });
  useEffect(() => {
    const interval = setInterval(() => {
      setSecondsLeft(prev => {
        const next = prev <= 0 ? TOTAL_SECONDS : prev - 1;
        sessionStorage.setItem('urgency-countdown', String(next));
        return next;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  return <div className="w-full max-w-md mx-auto space-y-4" data-id="element-239">
      {/* Countdown Box */}
      <div className="bg-[#7F1D1D] rounded-xl p-4 text-center shadow-[0_4px_20px_rgba(127,29,29,0.3)] pt-[10px] pb-[10px]" data-id="element-240">
        <h4 className="text-white text-base md:text-lg font-bold uppercase mb-0.5" data-id="element-241">
          OFERTA{' '}
          <span className="underline decoration-[#F7D060] decoration-2 underline-offset-4" data-id="element-242">
            SOLO POR HOY
          </span>{' '}
          !!!
        </h4>

        <div className="mt-2 space-y-0.5" data-id="element-243">
          <p className="text-white text-xs md:text-sm font-semibold leading-snug" data-id="element-244">
            Reserva válida por{' '}
            <span className="text-[#F7D060] font-bold italic text-sm" data-id="element-245">
              {pad(minutes)}
            </span>{' '}
            minutos.
          </p>
          <p className="text-white text-xs md:text-sm font-semibold leading-snug" data-id="element-246">
            Si no procedes,{' '}
            <span className="underline decoration-[#F7D060] decoration-2" data-id="element-247">
              tu descuento pasa
            </span>
          </p>
          <p className="text-white text-xs md:text-sm font-semibold leading-snug" data-id="element-248">
            a la siguiente persona.
          </p>
        </div>

        {/* Timer Display */}
        <div className="mt-3 flex items-center justify-center gap-2" data-id="element-249">
          <div className="flex flex-col items-center" data-id="element-250">
            <div className="bg-black/40 rounded-lg px-3 py-2 min-w-[56px] border border-white/10" data-id="element-251">
              <span className="text-white text-2xl md:text-3xl font-black tabular-nums tracking-wider" data-id="element-252">
                {pad(minutes)}
              </span>
            </div>
            <span className="text-white/70 text-[10px] font-bold mt-1 uppercase tracking-wider" data-id="element-253">
              Minutos
            </span>
          </div>

          <span className="text-white text-2xl md:text-3xl font-black mb-4" data-id="element-254">
            :
          </span>

          <div className="flex flex-col items-center" data-id="element-255">
            <div className="bg-black/40 rounded-lg px-3 py-2 min-w-[56px] border border-white/10" data-id="element-256">
              <span className="text-white text-2xl md:text-3xl font-black tabular-nums tracking-wider" data-id="element-257">
                {pad(seconds)}
              </span>
            </div>
            <span className="text-white/70 text-[10px] font-bold mt-1 uppercase tracking-wider" data-id="element-258">
              Segundos
            </span>
          </div>
        </div>
      </div>
    </div>;
}